module.exports = __webpack_public_path__ + "img/lessons.4f90505f.svg";